export const REQUEST_TYPE = {
	RANGE: 'selected-range-searches',
	WEEK: 'week-searches',
	MONTH: 'month-searches',
	BOOKING: 'booking',
	COUNTRY: 'company',
	USER: 'user',
	SITE: 'site',
	CHART: 'char',
	TABLE: 'table',
}